"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-codec-tools"
  }, [_c("div", {
    staticClass: "header-items"
  }, [_c("h5", {
    staticClass: "grid-h title-page"
  }, [_c("button", {
    attrs: {
      nbButton: ""
    },
    on: {
      click: _vm.goBack
    }
  }, [_c("b-icon", {
    attrs: {
      icon: "arrow-left"
    }
  })], 1), _vm._v("\n      Conversor de conteúdo\n    ")])]), _vm._v(" "), _c("div", {
    staticClass: "codec-panel"
  }, [_c("div", {
    staticClass: "codec-tabs"
  }, [_c("button", {
    class: {
      active: _vm.activeTab === "text"
    },
    attrs: {
      type: "button"
    },
    on: {
      click: function click($event) {
        _vm.activeTab = "text";
      }
    }
  }, [_vm._v("\n        Texto\n      ")]), _vm._v(" "), _c("button", {
    class: {
      active: _vm.activeTab === "image"
    },
    attrs: {
      type: "button"
    },
    on: {
      click: function click($event) {
        _vm.activeTab = "image";
      }
    }
  }, [_vm._v("\n        Imagem\n      ")])]), _vm._v(" "), _vm.activeTab === "text" ? _c("div", {
    staticClass: "codec-section"
  }, [_c("div", {
    staticClass: "codec-grid"
  }, [_c("div", {
    staticClass: "codec-field"
  }, [_c("label", [_vm._v("Conteúdo de entrada")]), _vm._v(" "), _c("textarea", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.textInput,
      expression: "textInput"
    }],
    attrs: {
      placeholder: "Cole um texto claro, hash ou conteúdo em Base64",
      spellcheck: "false"
    },
    domProps: {
      value: _vm.textInput
    },
    on: {
      input: function input($event) {
        if ($event.target.composing) return;
        _vm.textInput = $event.target.value;
      }
    }
  })]), _vm._v(" "), _c("div", {
    staticClass: "codec-field"
  }, [_c("label", [_vm._v("Resultado")]), _vm._v(" "), _c("textarea", {
    attrs: {
      readonly: "",
      placeholder: "O resultado será exibido aqui",
      spellcheck: "false"
    },
    domProps: {
      value: _vm.textOutput
    }
  })])]), _vm._v(" "), _c("div", {
    staticClass: "codec-actions"
  }, [_c("button", {
    attrs: {
      type: "button"
    },
    on: {
      click: _vm.encodeBase64
    }
  }, [_vm._v("\n          Converter para Base64\n        ")]), _vm._v(" "), _c("button", {
    attrs: {
      type: "button"
    },
    on: {
      click: _vm.decodeBase64
    }
  }, [_vm._v("\n          Desconverter Base64\n        ")]), _vm._v(" "), _c("button", {
    attrs: {
      type: "button"
    },
    on: {
      click: _vm.generateSha256
    }
  }, [_vm._v("\n          Gerar SHA-256\n        ")]), _vm._v(" "), _c("button", {
    attrs: {
      type: "button"
    },
    on: {
      click: _vm.generateMd5
    }
  }, [_vm._v("\n          Gerar MD5\n        ")]), _vm._v(" "), _c("button", {
    staticClass: "secondary",
    attrs: {
      type: "button"
    },
    on: {
      click: _vm.clearText
    }
  }, [_vm._v("\n          Limpar\n        ")])]), _vm._v(" "), _vm.textError ? _c("p", {
    staticClass: "codec-error"
  }, [_vm._v("\n        " + _vm._s(_vm.textError) + "\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm.activeTab === "image" ? _c("div", {
    staticClass: "codec-section"
  }, [_c("div", {
    staticClass: "codec-image-grid"
  }, [_c("div", {
    staticClass: "codec-field"
  }, [_c("label", [_vm._v("Imagem em Base64")]), _vm._v(" "), _c("textarea", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.imageInput,
      expression: "imageInput"
    }],
    attrs: {
      placeholder: "Cole uma imagem em Base64 com ou sem prefixo data:image",
      spellcheck: "false"
    },
    domProps: {
      value: _vm.imageInput
    },
    on: {
      input: [function ($event) {
        if ($event.target.composing) return;
        _vm.imageInput = $event.target.value;
      }, _vm.decodeImage]
    }
  })]), _vm._v(" "), _c("div", {
    staticClass: "codec-preview"
  }, [!_vm.imagePreview ? _c("span", [_vm._v("Prévia da imagem")]) : _c("img", {
    attrs: {
      src: _vm.imagePreview,
      alt: "Imagem convertida de Base64"
    },
    on: {
      error: _vm.handleImageError,
      load: function load($event) {
        _vm.imageError = "";
      }
    }
  })])]), _vm._v(" "), _c("div", {
    staticClass: "codec-actions"
  }, [_c("button", {
    attrs: {
      type: "button"
    },
    on: {
      click: _vm.decodeImage
    }
  }, [_vm._v("\n          Exibir imagem\n        ")]), _vm._v(" "), _c("button", {
    staticClass: "secondary",
    attrs: {
      type: "button"
    },
    on: {
      click: _vm.clearImage
    }
  }, [_vm._v("\n          Limpar\n        ")])]), _vm._v(" "), _vm.imageError ? _c("p", {
    staticClass: "codec-error"
  }, [_vm._v("\n        " + _vm._s(_vm.imageError) + "\n      ")]) : _vm._e()]) : _vm._e()])]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;